import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { weeklySchedule } from "@/mocks/anime";

export default function ScheduleSection() {
  const [activeDay, setActiveDay] = useState(weeklySchedule[2].day);

  return (
    <section id="schedule" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="排期公开透明"
        title="每周更新表"
        desc="把所有连载作品的开播时间集中在一张表里，先看哪天有空，再决定追哪些。手机上可左右滑动切换日期，点选日期即可查看当天排片。"
      />

      {/* Desktop table */}
      <div className="mt-8 hidden overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:block">
        <div className="grid grid-cols-7 divide-x divide-background-200">
          {weeklySchedule.map((day) => (
            <div key={day.day} className="p-4">
              <div className="flex items-baseline justify-between">
                <span className="font-heading text-xl text-foreground-950">{day.day}</span>
                <span className="text-[11px] tracking-widest text-foreground-400">{day.en}</span>
              </div>
              <div className="mt-3 space-y-3">
                {day.shows.map((show) => (
                  <div
                    key={show.title}
                    className="rounded-md border border-background-200 bg-background-100 p-2.5"
                  >
                    <p className="text-xs font-medium text-foreground-800">{show.title}</p>
                    <div className="mt-1.5 flex items-center justify-between text-[11px] text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-time-line" />
                        {show.time}
                      </span>
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                        {show.genre}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile day switcher */}
      <div className="mt-8 lg:hidden">
        <div
          role="tablist"
          aria-label="选择星期的更新表"
          className="hide-scrollbar flex gap-1.5 overflow-x-auto rounded-full border border-background-200 bg-background-50 p-1"
        >
          {weeklySchedule.map((day) => (
            <button
              key={day.day}
              role="tab"
              type="button"
              aria-selected={activeDay === day.day}
              onClick={() => setActiveDay(day.day)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer ${
                activeDay === day.day
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600"
              }`}
            >
              {day.day}
            </button>
          ))}
        </div>

        <div className="mt-4 space-y-3">
          {weeklySchedule
            .find((day) => day.day === activeDay)
            ?.shows.map((show) => (
              <div
                key={show.title}
                className="flex items-center justify-between rounded-md border border-background-200 bg-background-50 p-3.5"
              >
                <div>
                  <p className="text-sm font-medium text-foreground-900">{show.title}</p>
                  <span className="mt-1 inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line" />
                    {show.time}
                  </span>
                </div>
                <span className="shrink-0 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                  {show.genre}
                </span>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}